import { ChangeEvent } from 'react'
import { getConfirmMessage } from 'src/constants/terms/messages'
import { TermsListSpace } from 'src/types/api'
import { AllTermsBooleanType, FormObjectType } from 'src/types/react-hook-form'
import { isTermRequired } from './getRequiredTermsFromApi'

type TermItem = { Title?: string; Required?: 0 | 1 }

type CreateTermsAttributeParams = {
  termsData: TermsListSpace.AllTermsType & { Idx: number }
  telecomValue: string
  updateAllTermsAgree: (event: ChangeEvent<HTMLInputElement>) => void
  allTermsAgreeHandler: () => void
  showTermsPopup: (termsKey: string) => void
}

const TERMS_WITH_POPUP: (keyof AllTermsBooleanType)[] = [
  'Service',
  'PrivacyThirdParty',
  'PrivacyConsent',
  'SKTPrivacy',
  'KTPrivacy',
  'LGUPPrivacy',
  'Marketing',
  'Insurance',
]

const formatTextWithRequirement = (text?: string, isRequire?: 0 | 1) => {
  const requirementText = isRequire === 1 ? '(필수)' : '(선택)'
  if (text === undefined) return undefined
  return `${requirementText} ${text}`
}

const getRequired = (
  key: keyof AllTermsBooleanType,
  termsData: TermsListSpace.AllTermsType & { Idx: number },
  telecomValue: string,
) => {
  if (!isTermRequired(key, termsData)) return false
  return getConfirmMessage(telecomValue)
}

export function createTermsAttribute({
  termsData,
  telecomValue,
  updateAllTermsAgree,
  allTermsAgreeHandler,
  showTermsPopup,
}: CreateTermsAttributeParams): Record<keyof AllTermsBooleanType, Partial<FormObjectType>> {
  const buildTerm = (key: keyof AllTermsBooleanType): Partial<FormObjectType> => {
    const term = termsData[key as keyof typeof termsData] as TermItem | undefined
    const isOptional = key === 'Marketing' || key === 'Insurance'

    return {
      tag: key,
      register_options: isOptional
        ? { required: false }
        : {
            required: getRequired(key, termsData, telecomValue),
            onChange: updateAllTermsAgree,
          },
      termsTitle: formatTextWithRequirement(term?.Title, term?.Required),
      showTermsPopup: () => showTermsPopup(key),
    }
  }

  return {
    ...Object.fromEntries(TERMS_WITH_POPUP.map((key) => [key, buildTerm(key)])),
    allTerms: {
      tag: 'allTerms',
      register_options: {
        required: false,
        onClick: allTermsAgreeHandler,
      },
    },
    KTMVNO: {
      tag: 'KTMVNO',
      register_options: { required: false },
    },
  } as Record<keyof AllTermsBooleanType, Partial<FormObjectType>>
}
